export enum SailpointApplicationContainer {
    BR = "ALLBA"
}